import React from 'react';
import { Progress, Tag, Typography, message } from 'antd';
import { formatBytes } from '../../../shared/utils/format';
import { t as tt } from '../../../shared/i18n';

const { Text } = Typography;

export const GB = 1024 ** 3;
export const fmtBytes = (v) => formatBytes(Number(v) || 0);

/** 后端字段容错：个人 usage 用 storage_*，组织 usage 用 used/limit */
export const storageOf = (u) => ({
    used: Number(u?.storage_used ?? u?.used ?? 0),
    limit: Number(u?.storage_limit ?? u?.limit ?? 0),
});
export const trafficOf = (u) => ({
    used: Number(u?.traffic_used ?? 0),
    limit: Number(u?.traffic_limit ?? 0),
});

export const UsageBar = ({ label, used, limit, fmt = fmtBytes, t }) => {
    const unlimited = !limit || limit < 0;
    const pct = unlimited ? 0 : Math.min(100, Math.round((used / Math.max(1, limit)) * 100));
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
            {label && <Text type="secondary" style={{ minWidth: 96 }}>{label}</Text>}
            <Progress percent={pct} size="small" style={{ flex: 1, minWidth: 160, margin: 0 }}
                status={!unlimited && used >= limit ? 'exception' : undefined}
                format={() => `${fmt(used)} / ${unlimited ? t('Unlimited') : fmt(limit)}`} />
        </div>
    );
};

export const MODE_LABEL = { pool: '共享空间', org_pool: '共享空间', seat: '按席位', org_seat: '按席位', personal: '个人' };
export const ModeTag = ({ mode, t }) => <Tag style={{ margin: 0 }}>{t(MODE_LABEL[mode] || mode || '-')}</Tag>;

const STATUS = {
    active: ['green', '正常'],
    disabled: ['default', '已停用'],
    suspended: ['orange', '已暂停'],
    deleted: ['red', '已删除'],
    pending: ['blue', '开通中'],
};
export const StatusTag = ({ status, t }) => {
    const [color, label] = STATUS[status] || ['default', status || '-'];
    return <Tag color={color} style={{ margin: 0 }}>{t(label)}</Tag>;
};

/** apiClient 已对 HTTP 4xx(除 404)/5xx 弹过提示；这里只补 404 和非 HTTP 错误 */
export const toastErr = (e, fallback) => {
    if (!e?.status || e.status === 404) message.error(e?.error || e?.message || fallback || tt('操作失败'));
};

export const listOf = (r) => {
    const d = r?.data;
    if (Array.isArray(d)) return d;
    if (Array.isArray(d?.items)) return d.items;
    if (Array.isArray(d?.members)) return d.members;
    return [];
};
